import { useQueryClient } from '@tanstack/react-query'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { invalidateFillApplication } from '@/models/fillApplication'
import { FmcsaStep } from '../App/Customers/FillApplication/FmcsaStep'

/** Until FMCSA's carrier is confirmed for their DOT, the rest of the application has nothing to stand on. */
export function ConfirmCarrierCard({ orgId }: { orgId: string }) {
  const queryClient = useQueryClient()

  return (
    <Card>
      <CardHeader>
        <CardTitle>Find your company</CardTitle>
        <CardDescription>Enter your DOT number and we&apos;ll look your company up on FMCSA.</CardDescription>
      </CardHeader>
      <CardContent>
        <FmcsaStep
          orgId={orgId}
          confirmLabel="This is my company"
          onSaved={() => void invalidateFillApplication(queryClient, orgId)}
        />
      </CardContent>
    </Card>
  )
}
